import { render, staticRenderFns } from "./PortalUserInfoPanel.vue?vue&type=template&id=7e2b7c78&scoped=true&"
import script from "./PortalUserInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./PortalUserInfoPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PortalUserInfoPanel.vue?vue&type=style&index=0&id=7e2b7c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2b7c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
